import { render, staticRenderFns } from "./VCustomerGoto.vue?vue&type=template&id=87749be4&"
import script from "./VCustomerGoto.vue?vue&type=script&lang=js&"
export * from "./VCustomerGoto.vue?vue&type=script&lang=js&"
import style0 from "./VCustomerGoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports